import { Flex, ButtonGroup, Button, Box } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useState } from 'react';
import { dayLabel } from '../constants/time';
import { TimePicker } from '../custom/TimePicker';

const constructSchedule = (days, { start, end }) => {
  return days?.reduce((acc, curr, idx) => {
    if (curr) {
      acc[idx] = { start, end };
      return acc;
    }
    return acc;
  }, {});
};

const serializeSchedule = (schedules, isNew) => {
  if (isNew) {
    // default settings for new outreach
    return [[0, 1, 1, 1, 1, 1, 0], '09:00', '18:00'];
  }
  const daysArr = Array.from({ length: 7 }, () => 0);
  let start = null,
    end = null;
  const days = Object.keys(schedules).reduce((acc, schedule) => {
    if (!start) start = schedules[schedule].start;
    if (!end) end = schedules[schedule].end;
    daysArr[schedule] = 1;
    return acc;
  }, daysArr);

  return [days, start, end];
};

export const Schedule = ({
  isNew = false,
  schedule: outreachSchedule = {},
  onChange = () => {},
}) => {
  const [outreachDays, outreachStart, outreachEnd] = serializeSchedule(
    outreachSchedule,
    isNew
  );
  const [days, setDays] = useState(outreachDays);
  const [schedule, setSchedule] = useState({
    id: 1,
    start: outreachStart,
    end: outreachEnd,
  });

  const onScheduleChange = ({ start, end }) => {
    setSchedule({ start, end });
  };

  const onDayChange = (idx) => {
    setDays((prev) => {
      prev[idx] = prev[idx] === 0 ? 1 : 0;
      return [...prev];
    });
  };

  useEffect(() => {
    const finalSchedule = constructSchedule(days, schedule);
    onChange(finalSchedule);
  }, [days, schedule]); //eslint-disable-line

  return (
    <Flex>
      <Flex flex="1">
        <ButtonGroup spacing="4px" pl="3px">
          {days.map(function (day, i) {
            return (
              <Button
                p="5px"
                br={'8px'}
                mr="3px"
                boxShadow={
                  day
                    ? '0px 0px 0px 4px #DFE9FE'
                    : '0px 1px 2px 0px rgba(16, 24, 40, 0.05)'
                }
                _focus={{
                  boxShadow: day
                    ? '0px 0px 0px 4px #DFE9FE'
                    : '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
                }}
                border={day ? '1px solid #444CE7' : '1px solid #D0D5DD'}
                variant={'secondary'}
                key={i}
                onClick={() => {
                  onDayChange(i);
                }}
              >
                {dayLabel[i]}
              </Button>
            );
          })}
        </ButtonGroup>
      </Flex>
      <Box mr="4px">
        <TimePicker day={schedule} onChange={onScheduleChange} />
      </Box>
    </Flex>
  );
};
